import { faker } from "@faker-js/faker";

const paymentsListMock: any[] = [];

function generatePaymentsList(){
  return{
    id: faker.string.numeric({ length: { min: 1, max: 5 } }),
    name: faker.person.fullName(),
    reference_payment : faker.string.numeric({ length: 5 }),
    method: faker.helpers.arrayElement(['Tarjeta', 'Efectivo']),
    date: faker.date.between({ from: '2023-05-01T00:00:00.000Z', to: '2023-08-20T00:00:00.000Z' }),
    time_service: faker.helpers.arrayElement(['9:30', '10:00','10:30', '11:00','11:30','12:00', '12:30', '13:00', '13:30', '15:30', '16:00','16:30']),
    time_duration: faker.number.int({min: 1, max: 4}),
    amount: faker.finance.amount({min: 15 ,max: 300, dec: 2, symbol: '', autoFormat: false}),

    service: faker.helpers.arrayElement(['Descenso Sella', 'Parque Aventura', 'Rafting', 'Paintball', 'Senderismo', 'Espeleología','Barranquismo', 'Rutas en Buggie', 'Rutas a Caballo']),
    state_booking: faker.helpers.arrayElement(['RESERVA 25%', 'PAGADO', 'ANULADA']),
    seats: faker.number.int({min: 1, max: 15}),
    dni: faker.string.numeric({length: 8 }),
    email: faker.internet.email(),
    phone: faker.phone.number('###-###-###'),
    address: faker.location.streetAddress(),
    total_sell: faker.finance.amount({min: 15 ,max: 300, dec: 2, symbol: '', autoFormat: false}),
    note_booking: ['casco niño', 'teléfono nuevo'],
  };
}
for (let i = 0; i < 50; i++) {
  const payment = generatePaymentsList();
  paymentsListMock.push(payment);
}



export { paymentsListMock };
